module.exports = __webpack_public_path__ + "9d8344b34850c22692a5f55d8cc39257.woff2";